import { OUTAGE_NOTIFICATION_FILTER_TYPE } from '../common/enums';
import OutageNotification from '../entities/outageNotification';

const outageNotificationItemTransformationBeforeSave = (outageNotificationItem: OutageNotification) => {
    const isVersionFilter = outageNotificationItem.filterEnumDescription == OUTAGE_NOTIFICATION_FILTER_TYPE[1];
    const isGroupNameFilter = outageNotificationItem.filterEnumDescription == OUTAGE_NOTIFICATION_FILTER_TYPE[2];

    const notificationFrom = outageNotificationItem.notificationFrom;
    const notificationTo = outageNotificationItem.notificationTo;
    const outageFrom = outageNotificationItem.outageFrom;
    const outageTo = outageNotificationItem.outageTo;

    const transformedData = {
        ...outageNotificationItem,
        platform: outageNotificationItem.platformEnumDescription?.value,
        filter: outageNotificationItem.filterEnumDescription?.value,
        condition: isVersionFilter ? outageNotificationItem.conditionEnumDescription?.value : null,
        version: isVersionFilter ? outageNotificationItem.version : null,
        groupName: isGroupNameFilter ? outageNotificationItem.groupName : null,

        notificationFrom: notificationFrom?.toUTCString(),
        notificationTo: notificationTo?.toUTCString(),
        outageFrom: outageFrom ? outageFrom.toUTCString() : null,
        outageTo: outageTo ? outageTo.toUTCString() : null,
    };

    return transformedData;
};

export default outageNotificationItemTransformationBeforeSave;
